import { AxiosInstance } from "axios"
import { GenericResponse } from "."

export interface DispatchModel {}

export interface DispatchListRequest {
    from: string
    to: string
}

export interface paramData {
    company?: string
    warehouse?: string
}
export interface DispatchsPrintState {
    parcels: []
}

const dispatchApi = (apiInstance: AxiosInstance) => {
    const dispatchsList = async (data: paramData): Promise<GenericResponse> => {
        var params = data.company ? "shipping_company_id=" + data.company : ""
        params += data.warehouse ? "&warehouse=" + data.warehouse : ""
        var url = "parcels/ready-dispatch"
        url = params ? url + "?" + params : url
        const res: Promise<GenericResponse> = apiInstance.get(url)
        return res
    }

    const shippingCompanyList = async (warehouse: string): Promise<GenericResponse> => {
        let query = warehouse ? `?warehouse=${warehouse}` : ""
        const res: Promise<GenericResponse> = apiInstance.get(`/parcels/shipping-companies${query}`)
        return res
    }

    const printMenifest = async (parcelData: DispatchsPrintState): Promise<any> => {
        const addParcelDetail = apiInstance.post("/parcels/dispatch", parcelData)
        return addParcelDetail
    }

    return {
        dispatchsList,
        shippingCompanyList,
        printMenifest
    }
}

export default dispatchApi
